import React from "react";
import { styled } from "@mui/material/styles";
import MuiSwitch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";

const Android12Switch = styled(MuiSwitch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="white" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="white" d="M19,13H5V11H19V13Z"/></svg>')`,
      right: 12,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
  },
}));

interface Props {
  name: string;
  label?: string;
  formik?: any;
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
}

const Switch: React.FC<Props> = ({ name, label, formik, checked, onChange, disabled = false }) => {
  const isControlled = checked !== undefined && onChange !== undefined;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (disabled) return;
    if (isControlled) {
      onChange(e.target.checked);
    } else if (formik) {
      formik.setFieldValue(name, e.target.checked);
    }
  };

  return (
    <FormControlLabel
      control={
        <Android12Switch
          checked={isControlled ? checked : formik?.values?.[name] ?? false}
          onChange={handleChange}
          disabled={disabled}
        />
      }
      label={label}
    />
  );
};

export default Switch;